import * as React from 'react'
import axios from 'axios'
import { Typography, Grid, TextField, Box, Button } from '@mui/material'
import { DataGridPro } from '@mui/x-data-grid-pro'
import { useLoaderData } from 'react-router-dom'
import { ErrorAlert } from '../../alerts/ErrorAlert'
import { SuccessAlert } from '../../alerts/Success'
import { axiosErrorHandling } from '../../misc/other'


const columns = [
    {field: 'id', headerName: 'ID', flex: 1},    
    {field: 'customer_number', headerName: 'customer_number', flex: 2},
    {field: 'paragraphOne', headerName: '1st Text Box', flex: 3},
    {field: 'paragraphTwo', headerName: '2nd Text Box', flex: 3},
    {field: 'paragraphThree', headerName: '3rd Test Box', flex: 2},
    {field: 'email', headerName: 'Email', flex: 2}
    
]  


export const FeedBackAdmin = () =>{
    
    let loaderData = useLoaderData()

    const context = JSON.parse(window.localStorage.getItem('context'))
    
    const [comments, setComments] = React.useState('')
    const [data, setData] = React.useState(loaderData)
    const [disableButtons, setDisableButtons] = React.useState(true)
    const [feedbackSelected, setFeedbackSelected] = React.useState([])
    const [loading, setLoading] = React.useState(false)
    const [error, setError] = React.useState(false)
    const [errorMessage, setErrorMessage] = React.useState('')
    const [succesMessage, setSuccessMessage] = React.useState('')
    const [success, setSuccess] = React.useState(false)

    
    const closeError = () =>{
        setError(false)
    }
    const closeAlert = () =>{
        setSuccess(false)
    }
    

    let adminData = {first_name: context.first_name,
                     last_name: context.last_name,
                       admin_email: context.email,
                        }
   
const rowClick = (row) =>{
    let i = 0
    const newArray = Array.from(row.ids)
    if(!newArray.length || newArray.length!==1){setDisableButtons(true)}
    
    else{
        setDisableButtons(false)
        let rowSelected = []
        while (i<(data.length)){
            if(newArray.includes(data[i].id)){
                rowSelected.push(data[i])
                setFeedbackSelected(rowSelected)
                setComments(data[i].comments)
            }
            i++
        }

    }
    
}

const changeInComments = (event) =>{
    if(!event.target.value){
        setDisableButtons(true)
    
    }
    else {
        setDisableButtons(false)
        setComments(event.target.value)
    }

}

const replyClick = () => {
setLoading(true)
let replyData = [feedbackSelected[0], comments, adminData]
setComments(null)
axios({
    method: 'POST',
    url: 'api/oracle7/reply',
    data: replyData
}).then((result)=>{
    
    if(result.status===200){
        axios({method:'GET',
                url: 'api/oracle2/getfeedback'})
                .then(results=>{
                    setData(results.data)
                    setLoading(false)
                    let succesMessage = result.data
                    setSuccessMessage(succesMessage)
                    setSuccess(true)

                }).catch(err=>{
                    let errMessage = axiosErrorHandling(err)
                    setErrorMessage(errMessage)
                    setLoading(false)
                    setError(true)
                    
                })
        
    }else{

        let error = 'Here is the error in the reply call: '+ result.statusText
        setLoading(false)
        setErrorMessage(error)
        setError(true)

    }

}).catch(err=>{
    let message = axiosErrorHandling(err)
    setErrorMessage(message)
    setLoading(false)
    setError(true)
})

setLoading(false)

}

const closeClick = () =>{
    setLoading(true)
    setComments('')
    let closeData = [feedbackSelected[0], comments, adminData]
    axios({
        method: 'POST',
        url: 'api/oracle7/close',
        data: closeData
    }).then((result)=>{
        
        if(result.status===200){
            axios({method:'GET',
                url: 'api/oracle2/getfeedback'})
                .then(results=>{
                    setData(results.data)
                    setLoading(false)
                    let successMess = 'Feedback case Closed' + result.data
                    setSuccessMessage(successMess)
                    setSuccess(true)
                })
        
    
        }else{
    
            let errMessage = ('Here is the error: ', result.statusText)
            setLoading(false)
            setErrorMessage(errMessage)
            setError(true)

        }
    
    }).catch(err=>{
            setLoading(false)
            let errMessage = axiosErrorHandling(err)
            setErrorMessage(errMessage)
            setError(true)

    })
    
    
    

}



return (
    
    <Box sx={{minHeight:'80vh', mt: 15, mb: 2}}>
        <ErrorAlert open={error} handleClose={closeError} error={errorMessage}/>
        <SuccessAlert open={success} message={succesMessage} setClose={closeAlert}/>
        <Grid container direction='column' sx={{alignItems: 'center'}}>
            <Grid>
                <Typography variant='h3' align='center' color='secondary'>Feedback Page</Typography>
             </Grid>
            <Grid size={{xs: 10}}>
                <DataGridPro
                    sx={{mb: '1rem'}} 
                    rows={data}
                    loading={data.length===0}
                    columns={columns}
                    autoPageSize={true}
                    checkboxSelection
                    disableMultipleRowSelection={true}
                    columnBufferPx={150}
                    hideFooter={false}
                    onRowSelectionModelChange={rowClick}
                />
            </Grid>
             <Grid size={{xs: 10}}>
                <TextField
                    sx={{mb: '1rem'}} 
                    fullWidth
                    value={comments}
                    id='comments'
                    label="Comment"
                    multiline
                    rows={8}
                    variant='outlined'
                    onChange={changeInComments}
                />
            </Grid>
        </Grid>    
        <Grid container direction='row-reverse' sx={{alignItems:'flex-end', justifyItems:'right'}}>
            <Grid sx={{m: '1rem'}}>
                <Button loading={loading} variant='contained'color='primary' disabled={disableButtons} onClick={replyClick}>Reply</Button>
            </Grid>
            <Grid sx={{m: '1rem'}}>
                <Button loading={loading} variant='contained' color='secondary' disabled={disableButtons} onClick={closeClick}>Close</Button>

            </Grid>
        </Grid>

    
    </Box>
     
);
    


}